/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AptosSearchHandlerInfo } from '../models/AptosSearchHandlerInfo';
import type { AptosSearchRequest } from '../models/AptosSearchRequest';
import type { BabylonSearchHandlerInfo } from '../models/BabylonSearchHandlerInfo';
import type { BabylonSearchRequest } from '../models/BabylonSearchRequest';
import type { EvmSearchHandlerInfo } from '../models/EvmSearchHandlerInfo';
import type { EvmSearchRequest } from '../models/EvmSearchRequest';
import type { HumanitySearchHandlerInfo } from '../models/HumanitySearchHandlerInfo';
import type { HumanitySearchRequest } from '../models/HumanitySearchRequest';
import type { KiteSearchHandlerInfo } from '../models/KiteSearchHandlerInfo';
import type { KiteSearchRequest } from '../models/KiteSearchRequest';
import type { NexonSearchHandlerInfo } from '../models/NexonSearchHandlerInfo';
import type { NexonSearchRequest } from '../models/NexonSearchRequest';
import type { SomniaSearchHandlerInfo } from '../models/SomniaSearchHandlerInfo';
import type { SomniaSearchRequest } from '../models/SomniaSearchRequest';
import type { ZerogSearchHandlerInfo } from '../models/ZerogSearchHandlerInfo';
import type { ZerogSearchRequest } from '../models/ZerogSearchRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class SearchControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any OK
     * @throws ApiError
     */
    public search({
        requestBody,
    }: {
        requestBody: (AptosSearchRequest | EvmSearchRequest | NexonSearchRequest | HumanitySearchRequest | KiteSearchRequest | BabylonSearchRequest | SomniaSearchRequest | ZerogSearchRequest),
    }): CancelablePromise<Array<(AptosSearchHandlerInfo | EvmSearchHandlerInfo | NexonSearchHandlerInfo | HumanitySearchHandlerInfo | KiteSearchHandlerInfo | BabylonSearchHandlerInfo | SomniaSearchHandlerInfo | ZerogSearchHandlerInfo)>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/search',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
